import { c as _c } from "react/compiler-runtime";
import { ProfileSectionHeader } from "@website/home-ui/profile-section-header";
import { useJwtToken, useLoginStatus } from "@website/hooks/auth-manager";
import { useViewPort } from "@website/hooks/viewport";
import { LoginStatus } from "@website/store/store";
import { LoginModal } from "@website/widget/login";
import { useRouter } from "next/router";
import { FC, PropsWithChildren } from "react";
import { HeaderWrapper } from "..";
import { Navbar } from "../navbar";
export const Layout: FC<PropsWithChildren> = properties => {
  const $ = _c(13);
  const {
    children
  } = properties;
  const {
    isDesktop
  } = useViewPort();
  const {
    profileType
  } = useJwtToken();
  const router = useRouter();
  const isB2b = profileType === "B2B";
  const {
    loginStatus
  } = useLoginStatus();
  const shouldRenderChildren = loginStatus !== LoginStatus.Pending;
  const shouldShowMobileProfileHeader = !isDesktop && router.pathname === "/";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeaderWrapper />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== shouldShowMobileProfileHeader) {
    t1 = shouldShowMobileProfileHeader && <ProfileSectionHeader className="!border-b-0" iconName="account_circle" title={"\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"} />;
    $[1] = shouldShowMobileProfileHeader;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `w-full flex-1 gap-6 px-0 lg:flex lg:px-6 lg:pt-4 ${isB2b ? "xl:px-10" : "xl:mx-auto xl:w-[1200px]"} xl:px-0`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Navbar />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = shouldRenderChildren && children;
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isDesktop) {
    t6 = !isDesktop && <LoginModal />;
    $[7] = isDesktop;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex flex-col xl:block">{t0}{t1}{t5}{t6}</div>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};